import { ISelectOption } from "~/shared/ui/Fields/types";

import { FILTER_BY } from "./useStaffFilterData";

export type TStaffFilterValues = {
  filterBy: { value: string; label: string } | null;
  filterItems: Array<{ value: string | number; label: string }>;
  filterExpectations: Array<{ value: string | number; label: string }>;
  filterCourse: Array<{ value: string | number; label: string }>;
  period: Date | null;
};

export const FILTER_BY_SELECT_OPTION: ISelectOption[] = [
  { value: FILTER_BY.DEALER, label: "Дилер" },
  { value: FILTER_BY.CITY, label: "Город" },
  { value: FILTER_BY.AREA, label: "Субъект" },
  { value: FILTER_BY.COUNTRY, label: "Страна" },
  { value: FILTER_BY.FO, label: "ФО" },
];

export const FILTER_BY_SELECT_OPTION_MAP = new Map<
  keyof typeof FILTER_BY,
  ISelectOption
>(
  FILTER_BY_SELECT_OPTION.map((el) => [el.value as keyof typeof FILTER_BY, el]),
);

export const getStaffFilterDefaultValues = (
  isRu: boolean,
): TStaffFilterValues => ({
  filterBy: { value: FILTER_BY.DEALER, label: "Дилер" },
  filterItems: [
    {
      value: String(sessionStorage.getItem("currentDealerId") || ""),
      label:
        (isRu
          ? sessionStorage.getItem("currentDealerName")
          : sessionStorage.getItem("currentDealerNameEn")) ||
        (isRu ? "Не определен" : "Not defined"),
    },
  ],
  filterExpectations: [],
  filterCourse: [],
  period: new Date(),
});
